import { useTranslation } from 'react-i18next';

import {
  cardHolderPresence,
  cardHolderPresenceMap,
  TCardHolderPresenceType,
} from '@/features/cards/store/models/card.model';
import { PaymentTruncateCell } from '@/features/cards/components/CardTransactionsTable/PaymentTruncateCell';

interface IPaymentCardholderPresenceCellProps {
  posCardholderPresence?: TCardHolderPresenceType;
  shouldTrancate?: boolean;
}

export function PaymentCardholderPresenceCell({
  posCardholderPresence,
  shouldTrancate = true,
}: IPaymentCardholderPresenceCellProps) {
  const { t } = useTranslation();
  if (!posCardholderPresence) return <>/</>;

  const description =
    !!cardHolderPresenceMap[posCardholderPresence] &&
    cardHolderPresenceMap[posCardholderPresence] !== cardHolderPresence.UNKNOWN
      ? [
          posCardholderPresence,
          t(`pages.currentProfiles.cards.transactions.table.headers.cardHolderPresence.${posCardholderPresence}`),
        ].join(': ')
      : posCardholderPresence;

  return shouldTrancate ? (
    <PaymentTruncateCell textString={description} />
  ) : (
    <span className="typo-body-regular-paragraph text-secondary">{description}</span>
  );
}
